import { render, staticRenderFns } from "./followupHome.vue?vue&type=template&id=47d2fbc3"
import script from "./followupHome.vue?vue&type=script&lang=js"
export * from "./followupHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports